import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import styles from './styles.module.css'
import { Input } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import { IoIosAdd, IoIosRemove } from 'react-icons/io'
import moment from 'moment'
import EnrollModal from '../EnrollModal/EnrollModal'
import { getSubgroupMembers, expelSubgroupMembers } from '../../../actions/directoryBasicEducation'
import { createNotification } from '../../../components/Notifications/Notifications'

export default function MembersTab({
  values,
  handleChange,
  error,
  gid,
  cid,
  parallels,
}) {
  const dispatch = useDispatch()
  const { subgroupMembers } = useSelector(state => state.directoryBasicEducation)

  const [openEnrollModal, setOpenEnrollModal] = useState(false)
  const [selectedMids, setSelectedMids] = useState([])
  const anchorRef = useRef(null)

  useEffect(() => {
    if (gid) {
      dispatch(getSubgroupMembers(gid))
    }
  }, [gid, dispatch])

  const members = subgroupMembers || []

  // мультивыбор: Shift — диапазон от якоря, Ctrl/клик — по одному
  const handleRowClick = (e, index) => {
    const mid = members[index]?.mid
    if (e.shiftKey && anchorRef.current !== null) {
      const [from, to] = [Math.min(anchorRef.current, index), Math.max(anchorRef.current, index)]
      const rangeMids = members.slice(from, to + 1).map(m => m.mid)
      setSelectedMids(prev => [...new Set([...prev, ...rangeMids])])
    } else {
      setSelectedMids(prev => prev.includes(mid) ? prev.filter(id => id !== mid) : [...prev, mid])
      anchorRef.current = index
    }
  }

  const handleExpel = async () => {
    if (!selectedMids.length) {
      createNotification('error', 'Выделите учащихся для отчисления')
      return
    }
    const date = values?.date || moment().format('YYYY-MM-DD')
    const ok = await dispatch(expelSubgroupMembers(gid, date, selectedMids))
    if (ok) setSelectedMids([])
  }

  const closeEnroll = () => setOpenEnrollModal(false)

  return (
    <div className={styles.wrapper}>
      {openEnrollModal && (
        <EnrollModal
          closeModal={closeEnroll}
          gid={gid}
          cid={cid}
          date={values?.date || moment().format('YYYY-MM-DD')}
          enrolledMembers={members}
          parallels={parallels}
        />
      )}

      <div className={styles.toolbar}>
        <Button onClick={() => setOpenEnrollModal(true)}>
          <IoIosAdd size={22} />
          Зачислить
        </Button>
        <Button
          mode='white'
          className={styles.expelBtn}
          onClick={handleExpel}
          disabled={selectedMids.length === 0}
        >
          <IoIosRemove size={22} />
          Отчислить
        </Button>
        <div className={styles.datePick}>
          <Input
            label='Дата'
            name='date'
            value={values?.date}
            error={error('date')}
            onChange={handleChange}
            type='date'
          />
        </div>
      </div>

      <div className={styles.memberCard}>
        <div className={styles.memberScroll}>
          <table className={styles.memberTable}>
            <thead>
              <tr>
                <th>Ученик</th>
              </tr>
            </thead>
            <tbody>
              {members.length
                ? members.map((m, index) => (
                  <tr
                    key={m.mid}
                    className={cn({ [styles.selectedRow]: selectedMids.includes(m.mid) })}
                    onClick={(e) => handleRowClick(e, index)}
                  >
                    <td>{m.student || m.calc_fio || m.fio}</td>
                  </tr>
                ))
                : (
                  <tr>
                    <td className={styles.emptyCell}>Состав пуст</td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.pickHint}>Shift — выделить диапазон, Ctrl — по одному</div>
    </div>
  )
}
